import { useTranslation } from 'react-i18next';

import { Telegram2, Vk2 } from '@pulse-web-ui/icons';
import { useTheme } from '@pulse-web-ui/theme';
import type { BaseThemeType } from '@pulse-web-ui/theme';

import {
  SupportBlockContent,
  SupportBlockSubTitle,
  SupportBlockTitle,
  SupportButton,
  SupportButtonsWrapper,
} from './rgs-support.styles';

export const RGSSupportBlock = () => {
  const { t } = useTranslation();
  const theme = useTheme() as BaseThemeType;

  return (
    <SupportBlockContent>
      <SupportBlockTitle>
        {t('BEST_TO_PAY:headers.socialNetworks')}
      </SupportBlockTitle>
      <SupportBlockSubTitle>
        {t('BEST_TO_PAY:hints.lifeHacks')}
      </SupportBlockSubTitle>
      <SupportButtonsWrapper>
        <SupportButton
          variant="primary"
          icon={
            <Telegram2 width={24} color={theme.colors['on-accent'].primary} />
          }
          onClick={() => window.open('https://t.me/sk_rgs_online', '_blank')}
        >
          {t('COMMON:labels.telegram')}
        </SupportButton>
        <SupportButton
          variant="primary"
          icon={<Vk2 width={24} color={theme.colors['on-accent'].primary} />}
          onClick={() => window.open('https://vk.com/rgs.online', '_blank')}
        >
          {t('COMMON:labels.vk')}
        </SupportButton>
      </SupportButtonsWrapper>
    </SupportBlockContent>
  );
};
